import { shake256 } from 'js-sha3';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function stringToUint8Array(str) {
  return new Uint8Array(Buffer.from(str, "utf-8"));
}
__name(stringToUint8Array, "stringToUint8Array");
function generate32ByteKey(input) {
  const hash = shake256(input, 128);
  return hash;
}
__name(generate32ByteKey, "generate32ByteKey");
function generate12ByteNonce(input) {
  const nonce = shake256(input, 48);
  return nonce;
}
__name(generate12ByteNonce, "generate12ByteNonce");

export { generate12ByteNonce, generate32ByteKey, stringToUint8Array };
